import React from 'react'
import { count, pct } from './model'

// Where every lead in the range ended up, as one stacked bar. Segments add
// up to `total`; the legend carries the names and numbers, so colour never
// works alone.
export default function FunnelBar({ segments, total }) {
  const visible = segments.filter((s) => s.value > 0)
  return (
    <section className="card" aria-label="Lead outcomes" style={{ padding: 16 }}>
      <div
        role="img"
        aria-label={segments.map((s) => `${s.label}: ${count(s.value)}`).join(', ')}
        style={{ display: 'flex', gap: 2, height: 14, borderRadius: 4, overflow: 'hidden', background: 'var(--bg-raised)' }}
      >
        {total > 0 && visible.map((s) => (
          <div
            key={s.id}
            title={`${s.label}: ${count(s.value)} (${pct((s.value / total) * 100)})`}
            style={{ flexGrow: s.value, flexBasis: 0, minWidth: 3, background: s.color }}
          />
        ))}
      </div>
      <ul style={{ listStyle: 'none', margin: '12px 0 0', padding: 0, display: 'flex', flexWrap: 'wrap', gap: '8px 20px' }}>
        {segments.map((s) => (
          <li key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--text-secondary)' }}>
            <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: 3, background: s.color }} />
            {s.label}
            <strong style={{ color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums' }}>{count(s.value)}</strong>
            <span style={{ color: 'var(--text-muted)' }}>{total > 0 ? pct((s.value / total) * 100) : '0%'}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}
